export const vibrateShort = () => {
  navigator.vibrate?.(50);
};
